import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $shortDescription': {
      color: hexToRGBA(TextColors.light, TextOpacities.light2),
    },
  },
};
const lightTheme = {
  root: {
    '& $shortDescription': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light2),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    breadcrumb: {
      marginBottom: muiTheme.spacing(2),
    },
    heading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
    logo: {
      marginBottom: muiTheme.spacing(3),
      width: '100%',
      maxWidth: muiTheme.spacing(28),

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(5),
        width: 'auto',
      },
    },
    shortDescription: {
      marginBottom: muiTheme.spacing(3),
    },
  }),
  { name: 'GenTPDPageHeader' },
);

export default useStyles;
